import { Component} from '@angular/core';
import {HttpClientService} from "../../core/services/http-client.service";
import {CommonService} from "../../core/services/common.service";
import {ToastService} from "../../core/services/toast.service";

interface KycDocument {
  type: string;
  label: string;
  required: boolean;
  uploaded: boolean;
  file: File | null;
  documentId?: string;
}
@Component({
  selector: 'app-user-kyc',
  templateUrl: './user-kyc.component.html',
  styleUrls: ['./user-kyc.component.css']
})

export class UserKycComponent {

  documents: KycDocument[] = [
    { type: 'aadhaarFront', label: 'Aadhaar Card Front', required: true, uploaded: false, file: null },
    { type: 'aadhaarBack', label: 'Aadhaar Card Back', required: true, uploaded: false, file: null },
    { type: 'pan', label: 'PAN Card', required: true, uploaded: false, file: null },
    { type: 'cheque', label: 'Canceled Cheque', required: false, uploaded: false, file: null }
  ];

  submissionInProgress = false;
  progressValue = 0;
  customer: any;
  userCode: any;


  upiId: string = '';
  bank = {
    accountHolderName: '',
    ifsc: '',
    accountNumber: '',
    bankName: ''
  };

  indianBanks: string[] = [
    'State Bank of India',
    'HDFC Bank',
    'ICICI Bank',
    'Axis Bank',
    'Punjab National Bank',
    'Bank of Baroda',
    'Canara Bank',
    'Union Bank of India',
    'Kotak Mahindra Bank',
    'IndusInd Bank',
    'Yes Bank',
    'IDFC FIRST Bank',
    'Indian Bank',
    'Central Bank of India',
    'UCO Bank',
    'Bank of India',
    'Indian Overseas Bank',
    'Punjab & Sind Bank',
    'RBL Bank',
    'Federal Bank',
    'Bandhan Bank',
    'AU Small Finance Bank',
    'DCB Bank',
    'IDBI Bank',
    'Jammu & Kashmir Bank',
    'South Indian Bank',
    'City Union Bank'
  ];

  constructor(private httpService: HttpClientService, private common: CommonService, private toast: ToastService) {
    this.customer = this.common.getStorage('customer');
    this.userCode = this.customer.firstName.charAt(0).toUpperCase() +
      this.customer.lastName.charAt(0).toUpperCase();
  }

  onNativeFileSelect(event: Event, documentType: string): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files && input.files.length ? input.files[0] : null;
    if (!file) { return; }

    const document = this.documents.find(doc => doc.type === documentType);
    if (!document) { return; }

    document.file = file;
    this.uploadFile(file, documentType);
  }

  private uploadFile(file: File, documentType: string): void {
    const formData = new FormData();
    formData.append('file', file, file.name);

    this.httpService.postFile('document-upload', formData).subscribe({
      next: (data: any) => {
        if (data?.responseStatus?.toLowerCase() === 'success' && data?.response?.result) {
          const doc = this.documents.find(d => d.type === documentType);
          if (doc) {
            doc.uploaded = true;
            doc.documentId = data.response.document_id;
          }
          this.toast.success( "Uploaded successfully");
        } else {
          const msg = data?.response?.message || 'Unable to upload document';
          this.toast.error('Upload Failed' + msg);
        }
      },
      error: () => {
        this.toast.error('Failed to upload document');
      }
    });
  }

  onFileRemove(documentType: string): void {
    const document = this.documents.find(doc => doc.type === documentType);
    if (document) {
      document.file = null;
      document.uploaded = false;
      document.documentId = undefined;
    }
  }

  private isAnyBankFieldFilled(): boolean {
    const { accountHolderName, ifsc, accountNumber, bankName } = this.bank;
    return !!(accountHolderName || ifsc || accountNumber || bankName);
  }

  private isBankFormComplete(): boolean {
    const { accountHolderName, ifsc, accountNumber, bankName } = this.bank;
    return !!(accountHolderName && ifsc && accountNumber && bankName);
  }

  submitForVerification(): void {
    const missingDocs = this.documents.filter(doc => doc.required && !doc.uploaded);
    if (missingDocs.length > 0) {
      this.toast.error('Please upload all required documents');
      return;
    }

    if (this.isAnyBankFieldFilled() && !this.isBankFormComplete()) {
      this.toast.error('Please fill Account Holder, IFSC, Account Number and Bank Name.');
      return;
    }

    const requestBody = {
      bankDetails: {
        customerId: this.customer.id,
        accountHolderName: this.bank.accountHolderName,
        accountNumber: this.bank.accountNumber,
        ifscCode: this.bank.ifsc,
        bankName: this.bank.bankName,
        upiId: this.upiId,
        status: 'PENDING'
      },
      kycDocuments: this.documents
        .filter(doc => doc.uploaded && doc.documentId)
        .map(doc => ({
          customerId: this.customer.id,
          documentType: doc.type.toUpperCase(),
          documentId: doc.documentId.toString(),
          status: 'PENDING'
        }))
    };

    this.submissionInProgress = true;
    this.progressValue = 0;

    this.httpService.post('affiliate/create-affiliate-kyc', requestBody).subscribe({
      next: (data: any) => {
        this.submissionInProgress = false;
        this.toast.success('Your KYC has been submitted for verification');
        console.log('Server response:', data);
      },
      error: (err) => {
        this.submissionInProgress = false;
        this.toast.error(
          'Something went wrong. Please try again.'
        );
        console.error(err);
      }
    });
  }

}
